import Image from "next/image";
import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
width: 339px;
height: 310px;
border-radius: 0px 0px 7px 7px;
background: #FFFFFF;
box-shadow: 0px 4px 4px 0px #00000040;
padding-bottom: 20px;
`;

const HeadingText = styled.div`
font-size: 20px;
font-weight: 700;
line-height: 45px;
text-align: left;
/* width: 214px; */
color: #FF7624;
margin-left: 20px;
`;

const DescText = styled.div`
font-size: 20px;
font-weight: 400;
line-height: 29px;
text-align: left;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color: #454545;
width: 298px;
margin-left: 20px;
`;

export default function CESInnovationCard({ image, heading, desc }) {
  return (
    <div>
      <Wrapper>
        <div>
          <Image src={image} width="" height="" alt="Logo"></Image>
        </div>
        <HeadingText>{heading}</HeadingText>
        <DescText>{desc}</DescText>
      </Wrapper>
    </div>
  );
}
